// Copyright (C) 2022 TANNER AG

import React from "react";
import { useParams } from "react-router-dom";
import { ContentTypeGroup } from "../../../graphql";
import NavBar from "../../../components/navbar/NavBar";
import ContentIntro from "../../../components/content/ContentIntro";
import Box from "@mui/material/Box";
import Content from "../../../components/content/Content";
import useAsset from "../../../hooks/useasset";
import Stack from "@mui/material/Stack";
import ContentTopicLink from "../../../components/content/ContentTopicLink";
import Divider from "@mui/material/Divider";
import { formatNo, routes } from "../../../lib/utils";
import { Link } from "react-router-dom";
import ListItemRegular from "../../../components/listitem/regular/ListItemRegular";
import Container from "@mui/material/Container";
import Button from "@mui/material/Button";
import { ArrowRightIcon } from "../../../components/icons/MANIcons";
import Grid from "@mui/material/Grid";
import useTranslation from "../../../hooks/usetranslation";
import Spinner from "../../../components/Spinner";
import useContentTopic from "../../../hooks/usecontenttopic";
import useContentGroup from "../../../hooks/usecontentgroup";

const EMobilityTopic = () => {
    const { createImageUrl } = useAsset();
    const { topicKey } = useParams();
    const { group } = useContentGroup(ContentTypeGroup.Emobility);
    const { t } = useTranslation();
    const { topic, fetching } = useContentTopic(ContentTypeGroup.Emobility, [String(topicKey)]);

    if (fetching) {
        return <Spinner />;
    }

    return (
        <>
            <NavBar links={[{ label: group?.title, to: routes.eMobility }, { label: topic?.title }]} />
            <ContentIntro
                title={topic?.title ?? ""}
                no={topic?.no}
                theme={group?.title ?? ""}
                content={topic?.description ?? ""}
                additional={
                    <Stack spacing={1} sx={{ mt: 3 }}>
                        {topic?.topics?.map((subTopic) => (
                            <ContentTopicLink
                                key={subTopic.id}
                                id={subTopic.id}
                                to={subTopic.key}
                                title={subTopic.title}
                                no={formatNo([topic?.no, subTopic?.no])}
                            />
                        ))}
                    </Stack>
                }
            >
                {topic?.image && (
                    <Stack sx={{ alignItems: "flex-end" }}>
                        <Box
                            component="img"
                            src={createImageUrl(topic?.image)}
                            sx={{
                                width: 200,
                                height: 200,
                                objectFit: "cover",
                                borderRadius: 1
                            }}
                        />
                    </Stack>
                )}
            </ContentIntro>
            <Divider />
            <Box sx={{ pt: 4, bgcolor: "background.paper" }}>
                {topic?.sections?.map((section) => (
                    <Content key={section.id} id={section.id} section={section} />
                ))}
            </Box>
            <Container sx={{ py: 3 }}>
                <Grid container>
                    <Grid item sm={12} md={8}>
                        <Stack spacing={2}>
                            {topic?.topics?.map((subTopic) => (
                                <ListItemRegular
                                    key={subTopic.id}
                                    title={subTopic.title}
                                    image={subTopic.image}
                                    description={subTopic.description}
                                    no={formatNo([topic?.no, subTopic?.no])}
                                    action={
                                        <Button
                                            component={Link}
                                            to={subTopic.key}
                                            startIcon={<ArrowRightIcon color="secondary" />}
                                        >
                                            {t("learn_more")}
                                        </Button>
                                    }
                                />
                            ))}
                        </Stack>
                    </Grid>
                </Grid>
            </Container>
        </>
    );
};

export default EMobilityTopic;
